<template>
<div class ="shopcart" :class="{'highligh':totalCount>0}">
  <div class="shopcart-wrapper">
   <!--左侧购物车 -->
    <div class="content-left">
      <div class="logo-wrapper" :class="{'highligh':totalCount>0}">
         <span class="icon-shopping_cart logo" :class="{'highligh':totalCount>0}" @click="toogleList"></span> 
				 <i class="num" v-show="totalCount">{{totalCount}}</i>
      </div>
      <div class="desc-wrapper">
				 <p class="total-price">￥{{totalPrice}}</p>
         <!-- <p class="tip" :class="{'highligh':totalCount>0}">另需{{poinfo.shipping_fee_tip}}</p> -->
      </div>
	  
    </div>
   
    <!--右侧购物车 -->
    <div class="content-right" :class="{'highligh':totalCount>0}" @click="orderList">
     {{payStr}}<span v-if="payStr =='去结算' && lock == '1'">({{t}}s)</span>
    </div>
		<!-- 购物车列表 -->
		<div class="shopcart-list" v-show="listShow" :class="{'show':listShow}">
		<div class="list-top" v-if="poinfo.discounts2">
			{{ poinfo.discounts2[0].info}}
		</div>
		<div class="list-header">
			  <h3 class="title">我的口袋</h3>
				<div class="empty" @click="clearAll" >
					<img src="./img/ash_bin.png" />
					<span>清空购物车</span>
				</div>
		</div>
    <div class="list-content" ref="listContent">
			<ul style="padding:0;margin:0" >
				<li class="food-item" v-for="(food,index) in selectFoods " :key="index">
					<div class="desc-wrapper"  v-if="food.goods_id != 0">
						<div class="desc-left">
							<p class="name">{{food.freight_name}}</p>
							<p class="unit" v-show="!food.freight_countent">{{food.freight_unit}}</p>
							<p class="description" v-show="!food.freight_unit">{{food.freight_counten}}</p>
						</div>
						<div class="desc-right">
							￥{{food.price}}
						</div>
					</div>
					<div class="desc-wrapper" v-if="food.goods_id === 0">
						<div class="desc-left">
							<p class="name">{{food.No}}货道商品</p>
							<p class="unit">单位</p>
						</div>
						<div class="desc-right">
							￥{{food.price}}
						</div>
					</div>
					<div class="cartcontrol-wrapper">
						<app-cart-control :cartNum="cartNum" :imei="imei" :food="food" :selectCount="selectCount" :c_num="c_num" :lock="lock" :lock_times="lock_times" @showTips="showTips" @dec_times="dec_times"></app-cart-control>
					</div>
				</li>
			</ul>
		</div>
    <div class="list-bottom"></div>
	</div>
</div>
<div class="shopcart-mask" v-show="listShow" @click="hideMask"></div>
</div>
</template>

<script>
import BScroll from 'better-scroll'
import Cartcontrol from '../cartcontrol/Cartcontrol'
export default {
	components:{
     "app-cart-control":Cartcontrol
	},
  	data () {
		return {
			fold:true,
			t:'',
		}
	},
	props:{
     	poinfo:{
         type:Object,
         	default:{}
		},
		selectFoods:{
			 type:Array,
			 default(){
				 return[]
			 }
		},
		selectCount:{
        	type:Number
    	},
		c_num:{
			type:String
		},
		lock:{
			type:String
		},
		lock_times:{
			type:Number
		},
		imei:{
			type:String
		},
		cartNum:{
			type:Number
		},
		server_url:{
			type:String
		}
  	},
	methods: {
		dec_times(){
			for(let i=0 ;i < 1000; i++){
				clearInterval(i);
			}
			if(this.lock == '1'){
				var timer = null
				var times = this.lock_times
				var that = this
				timer = setInterval(function(){
					times--;
					that.t = times
					console.log(that.t)
					if (times <=0) {
						clearInterval(timer);
						var info = "您已超时，请退出该页面，重新扫码购买"
						that.$emit("showMessages",info)
						//window.opener=null;
						//window.close();
					}
				},1000);
			}
		},
		hideMask(){
			//console.log("hideMask")
       		this.fold=true
		},
		clearAll(){
			// 开启锁库存
			if(this.lock == '1'){
				for(let i=0 ;i < 1000; i++){
					clearInterval(i);
				}
				console.log(this.c_num)
				//console.log("clearAll")
				console.log(this.selectFoods)
				this.postInfo= { "imei":this.imei, "goods":this.selectFoods, "c_num":this.c_num }
				console.log(this.postInfo)
				const url = this.server_url+"/server/c/dec_all_goods"
				this.axios.post(   //请求方式
				url,  //添加商品接口地址
				this.postInfo  //传递参数 
				)    
				.then(response =>{
					if(response.data.code == 2000){
						this.selectFoods.forEach((food)=>{
							console.log(food.count)
							food.count = 0
						})
						console.log('调用父方法')
						//将选择商品数初始化
						this.$emit('clearSelectCount')
					}
				})
			}
			//未开启锁库存
			if(this.lock == '0'){
				this.selectFoods.forEach((food)=>{
					console.log(food.count)
					food.count = 0
				})
				console.log('调用父方法')
				//将选择商品数初始化
				this.$emit('clearSelectCount')
			}
		},
		toogleList(){
			//console.log("toogleList")
			//判断购物车个数是否为空
			if(!this.totalCount){
				return
		}
		this.fold=!this.fold
		},
		orderList(){
			//console.log("orderList")
			//关闭所有定时器
			for(let i=0 ;i < 1000; i++){
				clearInterval(i);
			}
			if(this.payStr == "去结算"){
				// 开启锁库存
				if(this.lock == '1'){
					//请求接口
					this.postInfo= { "imei":this.imei, "goods":this.selectFoods, "c_num":this.c_num }
					const url = this.server_url+"/server/c/cart_check_goods"
					let that = this
					this.axios.post(   //请求方式
					url,  //添加商品接口地址
					this.postInfo  //传递参数 
					)    
					.then(response =>{
						if(response.data.code == 2000){
							this.$emit('selectGoods',this.selectFoods)
						}else{
							that.$emit("showMessages",response.data.msg)
						}
					})
				}
				//未开启锁库存
				if(this.lock == '0'){
					this.$emit('selectGoods',this.selectFoods)
				}
				
			}
			
		},
		showTips(info){
			this.$emit('showTips',info)
		}

	},
	computed: {
		listShow(){
		//console.log("listShow")
      		if(!this.totalCount){
				this.fold=true
				return false
			}
			let show =!this.fold
			if(show){
				this.$nextTick(()=>{
          		if(!this.shopScroll){
						this.shopScroll=new BScroll(this.$refs.listContent,{
							click:true
						})
					}else{
						this.shopScroll.refresh()
					}
				})
			}
			return show
		},
		payStr(){
			//console.log("payStr")
       		if(this.totalCount>0){
				this.dec_times()
				return "去结算"
			}else{
				 //return this.poinfo.min_price_tip
				return "购物车空空！"
			}
		},
		totalCount(){
			//console.log("totalCout")
			let num =0
			this.selectFoods.forEach((food)=>{
				num+=food.count
			})
			return num
		},
		totalPrice(){
				//console.log("totalPrice")
				let total=0
				this.selectFoods.forEach((food)=>{
		           total+=Number(food.price)*Number(food.count)
		           total = Math.round(total*100)/100   //四舍五入保留2位小数
				})
				return total
		}
	},
  	
}

</script>


<style>
@import url('../../common/css/style.css');

.shopcart-wrapper{
	width: 100%;
	height: 51px;
	background: #514f4f;
	position: fixed;
	left: 0;
	bottom: 0;
	display: flex;
	z-index: 99;
}

.shopcart-wrapper .content-left{
	flex: 1;
}

.shopcart-wrapper .content-right{
	flex: 0 0 110px;
  	font-size: 15px;
	color: #BAB9B9;
	line-height: 51px;
	text-align: center;
	font-weight: bold;
}

.shopcart-wrapper .content-left .logo-wrapper{
	width: 50px;
	height: 50px;
	background: #666666;
	border-radius: 50%;
	position: relative;
	top: -14px;
	left: 10px;
	text-align: center;
	float: left;
}

.shopcart-wrapper .content-left .logo-wrapper .logo{
	font-size: 28px;
	color: #c4c4c4;
	line-height: 50px;
}

.shopcart-wrapper .content-left .desc-wrapper{
	float: left;
	margin-left: 13px;
}

.shopcart-wrapper .content-left .desc-wrapper .tip{
	font-size: 12px;
	color: #bab9b9;
	line-height: 51px;
}


.shopcart-wrapper .content-left .logo-wrapper.highligh{
	background: #ffd161;
}
.shopcart-wrapper .content-left .logo-wrapper .logo.highligh{
	color: #2D2B2A;
}
.shopcart-wrapper .content-left .logo-wrapper .num{
	width: 20px;
	height: 20px;
	line-height: 20px;
	text-align: center;
	border-radius: 50%;
	font-size: 9px;
	color: white;
	background: red;
	position: absolute;
	right: 0;
	top: -2px;
}
.shopcart-wrapper .content-left .desc-wrapper .tip.highligh{
	line-height: 10px;
}


.shopcart-wrapper .content-right.highligh{
	background: #FFD161;
	color: #2D2B2A;
}

.shopcart-wrapper .content-left .desc-wrapper .total-price {
    font-size: 20px;
    line-height: 50px;
    color: white;
}

.shopcart-wrapper .shopcart-list{
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
	width: 100%;
}
.shopcart-wrapper .shopcart-list.show{
	transform: translateY(-100%);
}

.shopcart-wrapper .shopcart-list .list-top{
	height: 30px;
	text-align: center;
	font-size: 11px;
	background: #f3e6c6;
	line-height: 30px;
	color: #646158;
}

.shopcart-wrapper .shopcart-list .list-header{
	height: 30px;
	background: #F4F4F4;
}
.shopcart-wrapper .shopcart-list .list-header .title{
	float: left;
	border-left: 4px solid #53c123;
	padding-left: 6px;
	line-height: 3px;
	font-size: 12px;
}
.shopcart-wrapper .shopcart-list .list-header .empty{
	float: right;
	line-height: 30px;
	margin-right: 10px;
	font-size: 0;
}
.shopcart-wrapper .shopcart-list .list-header .empty img{
	height: 14px;
	margin-right: 9px;
	vertical-align: middle;
}
.shopcart-wrapper .shopcart-list .list-header .empty span{
	font-size: 12px;
	vertical-align: middle;
}

.shopcart-wrapper .shopcart-list .list-content{
	max-height: 360px;
	width:100%;
	overflow: hidden;
	background: white;
}
.shopcart-wrapper .shopcart-list .list-content .food-item{
	height: 30px;
	padding: 12px 12px 25px 12px;
	border-bottom: 1px solid #F4F4F4;
	list-style: none;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper{
	float: left;
	width: 240px;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-left{
	float: left;
	width: 170px;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-left .name{
	font-size: 16px;
	margin-bottom: 8px;
	
	
	/* 超出部分隐藏*/
	-webkit-line-clamp: 1;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
	height: 20px;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-left .unit{
	font-size: 12px;
	color: #B4B4B4;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-left .description{
	font-size: 12px;
	color: #B4B4B4;
		
	/* 超出部分隐藏*/
	overflow: hidden;
	height: 12px;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-right{
	float: right;
	width: 70px;
	text-align: right;	
	padding-top: 6px;
}
.shopcart-wrapper .shopcart-list .list-content .food-item .desc-wrapper .desc-right .price{
	font-size: 12px;
	line-height: 38px;
}

.shopcart-wrapper .shopcart-list .list-content .food-item .cartcontrol-wrapper{
	float: right;
	margin-top: 6px;
}

.shopcart .shopcart-mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 98;
	background: rgba(7,17,27,0.6);
}


</style>


// WEBPACK FOOTER //
// src/components/shopcart/Shopcart.vue